"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetValidationService = void 0;
var joi_1 = __importDefault(require("joi"));
var Result_1 = require("../../../../../models/concrete/Result");
var SetValidationService = /** @class */ (function () {
    function SetValidationService() {
        this.schemaForGetSets = joi_1.default.object().keys({
            page: joi_1.default.number().optional(),
            setId: joi_1.default.number().optional()
        });
        this.schemaForGetSetBySlug = joi_1.default.object().keys({
            slug: joi_1.default.string().required()
        });
    }
    SetValidationService.prototype.getSetsData = function (data) {
        var error = this.schemaForGetSets.validate(data).error;
        // debug
        console.debug('Validating get sets data', JSON.stringify(data));
        if (error) {
            console.debug('Validation failed');
            console.debug(error.details[0].message);
            return Result_1.Result.fail(error.details[0].message);
        }
        else {
            console.debug('Validation went successful');
        }
        return Result_1.Result.ok('');
    };
    SetValidationService.prototype.getSetBySlugData = function (data) {
        var error = this.schemaForGetSetBySlug.validate(data).error;
        // debug
        console.debug('Validating get set by slug data', JSON.stringify(data));
        if (error) {
            console.debug('Validation failed');
            console.debug(error.details[0].message);
            return Result_1.Result.fail(error.details[0].message);
        }
        else {
            console.debug('Validation went successful');
        }
        return Result_1.Result.ok('');
    };
    return SetValidationService;
}());
exports.SetValidationService = SetValidationService;
//# sourceMappingURL=SetValidationService.js.map